import { connect } from "react-redux";
import FidelityCardNumberInput from "app/pages/.shared/FidelityCardNumberInput";
import { getFlightInboundAirlineCode } from "app/pages/Booking/bookingSelectors";
import { getLoyalty } from "app/reducers/brandSelector";

const mapStateToProps = state => {
	return {
		airlineCode: getFlightInboundAirlineCode(state),
		resolution: state.resolution,
		loyalty: getLoyalty(state),
	};
};

export default connect(mapStateToProps)(FidelityCardNumberInput);
